exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".axis path,.axis line{fill:none;stroke:#000;shape-rendering:crispEdges}.area1{fill:#f9d057b3}.area2{fill:#36aeafa6}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/multiAreaChart/multiAreachart.style.scss
// module id = 1567
// module chunks = 0